'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _styledComponents=require('styled-components');Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _styledComponents.withTheme}});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vitalsource/vstui/themes/withTheme.js
// module id = 164
// module chunks = 162